/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'nav/sidebar/changelog': {
    width: 19,
    height: 14,
    viewBox: '0 0 19 14',
    data: '<path pid="0" d="M1 7.071h15.786M1 13.143h17M1 1h8.5" _stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
